import { render } from "./BackupScheduleWizard.vue?vue&type=template&id=7ce48c7c&scoped=true"
import script from "./BackupScheduleWizard.vue?vue&type=script&lang=js"
export * from "./BackupScheduleWizard.vue?vue&type=script&lang=js"

import "./BackupScheduleWizard.vue?vue&type=style&index=0&id=7ce48c7c&scoped=true&lang=less"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce48c7c"]])

export default __exports__